export const newLocationId = "new-location-id";
